import './index.css';
import View from '../view';
import Text from '../text';
import Image from '../image';
import Constants from '../../constants';
import Button from '@mui/material/Button/Button';
import React from 'react';
import I18n from '../../utilities/locale';
import MobileWrapper from '../mobile_wrapper';
declare const window: any;

const ErrorBoundaryContent = () => {
  const onPressRestart = () => {
    if (!window?.ReactNativeWebView) {
      window.location.reload();
    }
  };

  return (
    <MobileWrapper>
      <View className={'error-boundary-content-container'}>
        <Image source={Constants.Images.Oops} className={'error-boundary-content-oops-image'} />
        <Text className={'error-boundary-content-text'}>{'Something went wrong'}</Text>
        <Text className={'error-boundary-content-text'}>{'We will need to restart the app.'}</Text>
        <Button className={'error-boundary-content-button'} onClick={onPressRestart}>
          {I18n.t('restart')}
        </Button>
      </View>
    </MobileWrapper>
  );
};

export default React.memo(ErrorBoundaryContent);
